function calculateAge(birthDate) {
    const today = new Date();
    const birthDateFormatted = new Date(birthDate);
    let age = today.getFullYear() - birthDateFormatted.getFullYear();
    const monthDiff = today.getMonth() - birthDateFormatted.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateFormatted.getDate())) {
        age--;
    }

    return age;
}

export default calculateAge;